import React from 'react';
import { Icon } from '@chakra-ui/react';
import { UnlockIcon } from '@chakra-ui/icons';

import ProtocolGenerator from 'views/admin/protocol';
import DiseaseProtocol from 'views/admin/diseaseProtocol';
import SystemProtocol from 'views/admin/system';
import MasterRemedy from 'views/admin/masterRemedy';
import SystemAxisWeight from 'views/admin/systemAxisWeight';
import SystemAxisMapping from 'views/admin/systemAxisMapping';
import PatientsHistory from 'views/admin/patientsHistory';
import User from 'views/admin/users';
import SignInCentered from 'views/auth/signIn';
import DoctorUser from 'views/admin/DoctorUser';
import SavedDiseaseProtocol from 'views/admin/savedDiseaseProtocol';
import ResetPassword from 'views/auth/resetPassword';
import {
  FaBook,
  FaBoxOpen,
  FaBullhorn,
  FaClipboardCheck,
  FaClipboardList,
  FaFileMedicalAlt,
  FaInfoCircle,
  FaNotesMedical,
  FaQuestionCircle,
  FaStethoscope,
  FaUserInjured,
  FaUserMd,
  FaUsers,
} from 'react-icons/fa';
import {
  FiClock,
  FiFileText,
  FiSave,
  FiSettings,
  FiYoutube,
} from 'react-icons/fi';
import PatientManagement from 'views/admin/patientManagement';
import PatientsHistoryManagement from 'views/admin/patientHistoryManagement';
import PlansManagement from 'views/admin/planManagement';
import CustomNotification from 'views/admin/costumeNotification';
import ProductManagement from 'views/admin/productManagement';
import GeneralInformation from 'views/admin/generalInformation';
import ApplicationGuidelines from 'views/admin/applicationGuidelines';
import ElectropathyBook from 'views/admin/electropathyBook';
import AboutSection from 'views/admin/aboutSection';
import HowToUseApplication from 'views/admin/howToUseApplication';

const allRoutes = [
  // OPD
  {
    name: 'OPD',
    layout: '/admin',
    path: '/protocol',
    icon: <Icon as={FaNotesMedical} boxSize={5} />,
    component: <ProtocolGenerator />,
    secondary: true,
  },

  // MASTER
  {
    name: 'Master',
    icon: <Icon as={FiSettings} boxSize={5} />,
    collapse: true,
    items: [
      {
        name: 'Disease Protocol',
        layout: '/admin',
        path: '/diseaseProtocol',
        icon: <Icon as={FiFileText} boxSize={5} />,
        component: <DiseaseProtocol />,
      },
      {
        name: 'Saved Disease Protocol',
        layout: '/admin',
        path: '/savedDiseaseProtocol',
        icon: <Icon as={FiSave} boxSize={5} />,
        component: <SavedDiseaseProtocol />,
      },
    ],
  },

  // Patient Management
  {
    name: 'Patient Management',
    icon: <Icon as={FaUsers} boxSize={5} />,
    collapse: true,
    items: [
      {
        name: 'Patients',
        icon: <Icon as={FaUserInjured} boxSize={5} />,
        layout: '/admin',
        path: '/register-patient',
        component: <PatientManagement />,
      },
      {
        name: 'Patients History',
        layout: '/admin',
        icon: <Icon as={FaFileMedicalAlt} boxSize={5} />,
        path: '/history-patient',

        component: <PatientsHistoryManagement />,
      },
    ],
  },

  // Practitioners Management
  {
    name: 'Practitioners Management',
    icon: <Icon as={FaStethoscope} boxSize={5} />,
    collapse: true,
    items: [
      {
        name: 'Practitioners',
        icon: <Icon as={FaUserMd} boxSize={5} />,
        layout: '/admin',
        path: '/practitioner-management',
        component: <DoctorUser />,
      },
      {
        name: 'Practitioners Patients History',
        layout: '/admin',
        path: '/practitioners-patients-history',
        icon: <Icon as={FiClock} boxSize={5} />,
        component: <PatientsHistory />,
      },
    ],
  },

  // Videos Management
  {
    name: 'Videos Management',
    icon: <Icon as={FiYoutube} boxSize={5} />,
    collapse: true,
    items: [
      {
        name: 'General Information',
        layout: '/admin',
        path: '/general-information',
        icon: <Icon as={FaInfoCircle} boxSize={5} />,
        component: <GeneralInformation />,
      },
      {
        name: 'Application Guidelines',
        layout: '/admin',
        path: '/application-guidelines',
        icon: <Icon as={FaClipboardCheck} boxSize={5} />,
        component: <ApplicationGuidelines />,
      },
    ],
  },

  // Other Management
  {
    name: 'Plans Management',
    layout: '/admin',
    path: '/plans-management',
    icon: <Icon as={FaClipboardList} boxSize={5} />,
    component: <PlansManagement />,
    secondary: true,
  },
  {
    name: 'Custom Notification',
    layout: '/admin',
    path: '/custom-notification',
    icon: <Icon as={FaBullhorn} boxSize={5} />,
    component: <CustomNotification />,
    secondary: true,
  },
  // {
  //   name: 'Product Management',
  //   layout: '/admin',
  //   path: '/product-management',
  //   icon: <Icon as={FaBoxOpen} boxSize={5} />,
  //   component: <ProductManagement />,
  //   secondary: true,
  // },
  {
    name: 'Electropathy Book',
    layout: '/admin',
    path: '/electropathy-book',
    icon: <Icon as={FaBook} boxSize={5} />,
    component: <ElectropathyBook />,
    secondary: true,
  },
  {
    name: 'About Section',
    layout: '/admin',
    path: '/about-section',
    icon: <Icon as={FaInfoCircle} boxSize={5} />,
    component: <AboutSection />,
    secondary: true,
  },
  {
    name: 'How To Use Application',
    layout: '/admin',
    path: '/how-to-use-application',
    icon: <Icon as={FaQuestionCircle} boxSize={5} />,
    component: <HowToUseApplication />,
    secondary: true,
  },

  // AUTH
  {
    name: 'Sign In',
    layout: '/auth',
    path: '/sign-in',
    icon: <Icon as={UnlockIcon} />,
    component: <SignInCentered />,
  },
  {
    name: 'Reset Password',
    layout: '/auth',
    path: '/reset-password',
    component: <ResetPassword />,
  },
];

export default allRoutes;
